export function buildRedirectLoginUrl(referrer: string | null, cookieReturnUrl: string | null) {
  let url = new URL('/', window.location.origin)

  if (referrer) {
    url = new URL(decodeURIComponent(referrer))
  }

  if (cookieReturnUrl) {
    url = new URL(decodeURIComponent(cookieReturnUrl))
  }

  url.searchParams.append('from', 'signUpSuccess')
  return url.toString()
}
